import { Injectable } from '@angular/core';

@Injectable()
export class ThemeService {
  removeAnimation = false;
}
